/**
 * @description 表格
 */
import './index.scss';
import { IPageInfo } from '@umu/umu-types';
import React from 'react';
import { IColumn, IData } from '../customTable/interface';
import Loading from '../loading/loading';
import { CustomTable } from '../customTable';
import TableSkeleton from '../tableSkeleton';
import { PaginationV2 } from 'businessCommon/src/components/pagination';

export interface IProps {
    columns: IColumn[];
    pageInfo: IPageInfo;
    loading: boolean;
    list: IData[];
    miniNumTdWidth?: number;
    emptyMsg: string | JSX.Element;
    onColumnClick?: (item: IData, dataIndex?: string) => void;
    onPageChange: (currentPage: number) => void;
}

const renderEmpty = (msg: string | JSX.Element) => {
    return (
        <div className="empty-data">
            <div className="empty-list" />
            <div className="empty-msg">{msg}</div>
        </div>
    );
};

export function TaskTable(props: IProps) {
    const { pageInfo, loading, list, emptyMsg } = props;
    const renderPlaceholder = () => {
        if (loading) {
            return <Loading />;
        }
        if (list.length > 0) {
            return '';
        }
        return renderEmpty(emptyMsg);
    };

    const renderPagination = () => {
        return Number(pageInfo.total_page_num) > 1 ? (
            <div className="render-pagination">
                <PaginationV2
                    forceShow={true}
                    showSizeChanger
                    currentPage={pageInfo.current_page}
                    maxPage={Number(pageInfo.total_page_num) || 1}
                    onPageChange={props.onPageChange}
                />
            </div>
        ) : null;
    };

    const renderDataTable = () => {
        return (
            <CustomTable
                onColumnClick={props.onColumnClick as any}
                columns={props.columns as any}
                data={loading ? [] : list}
                blank={renderPlaceholder()}
            ></CustomTable>
        );
    };

    return (
        <div className={`task-table${list.length > 0 ? '' : ' empty-task-table'}`}>
            {loading ? (
                <TableSkeleton columns={5} count={8} showStripes />
            ) : (
                <>
                    {renderDataTable()}
                    {renderPagination()}
                </>
            )}
        </div>
    );
}
